import styled, { css } from 'styled-components';
import { Form } from 'react-bootstrap';
import { theme } from '../../../../theme/theme';

const { first } = theme;

// Define element styles for the component
export const StyledControl = styled(Form.Control)`
  border-radius: .5rem;
  border: 1px solid #C4C4C4;
  background: #fff;
  color: #212529;
  outline: none;

  ${({isNewDesign}) => isNewDesign && css`
    background: rgba(255, 255, 255, 0.16);
    border: 1px solid rgba(255, 255, 255, 0.38);
    color: #fff;

    &:hover {
      background: rgba(255, 255, 255, 0.28) !important; 
    }

    &::placeholder {
      color: rgba(255, 255, 255, 0.8);
    }
  `}

  &:focus {
    border-color: ${first};
    box-shadow: none;
  }
`;

export const StyledGroup = styled(Form.Group)`
  background: transparent;
  margin-bottom: 20px;
`;